import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { notificationsKeys } from './keys';

const REFETCH_INTERVAL_MS = 60 * 1000;

export function useUnreadNotificationsCount() {
  return useQuery({
    queryKey: notificationsKeys.unreadCount(),
    queryFn: () => {
      return apiClient.get<ApiResponse<number>>('/v1/me/notifications/count', undefined);
    },
    refetchInterval: REFETCH_INTERVAL_MS,
  });
}
